<template>
    <div class="history-list m-auto">
        <template v-if="purchases.length > 0">
            <HistoryItem
            v-for="(campaign) in purchases"
            :key="campaign.id"
            :purchase="campaign"
            @onClickPurchase="clickPurchase(campaign)"
        ></HistoryItem>
        </template>
        <template v-else>
            <div class="grid justify-items-center mt-4">
                <div>
                    <img
                        class="object-cover max-w-72 max-h-72"
                        src="@/assets/History/Illustration_No_Register@3x.png"
                        alt=""
                    />
                </div>
                <div class="m-auto mx-4 text-center ">
                    <div class="text-22 mb-8 text-a-gray-afafaf leading-9">
                        ไม่พบประวัติการรับสิทธิ์
                    </div>
                    <div class="text-12 text-a-gray-afafaf leading-5">
                        หากพบปัญหาการใช้งาน
                        <br />
                        ติดต่อศูนย์บริการลูกค้า บริษัท บัซซี่ บีส์ จำกัด
                        <br />
                        <div
                            class="text-12 text-a-orange-fe5000 underline underline-offset-2"
                            @click="callPhone()"
                        >
                            โทร. 02-645-1203
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
import Account from '@/helper/AccountHelper.js';
import Util from '@/helper/Utility.js';
import Locale from '@/helper/locale/Locale.js';
import ConfigManager from '@/config/ConfigManager.js';
import { CampaignType } from '@/helper/StaticValue.js';
//component
import HistoryItem from './HistoryItem.vue';
//mixin
import ModalMixin from '@/mixin/ModalMixin';
//service
import BzbsHistory from '@/core/History/service/BzbsHistory.js';
import { SerialModel } from '@/core/Redeem/model/SerialModel.js';
import { WebInterfaceController } from '@/module/Detail/controller/WebInterfaceController';

export default {
    name: 'HistoryList',
    mixins: [ModalMixin],
    components: {
        HistoryItem,
    },
    props: {
        listConfig:   { type: Object, required: true },
        filterConfig: { type: Object, required: true },
    },
    data: function() {
        return {
            purchases: [],
            isLoading: false,
            isLoaded: false,
            isHaveItem: false,

            isSerialLoading: false,
        };
    },
    methods: {
        //#region history list
        getList: function () {
            return new Promise((resolve) => {
                this.isLoading = true;
                BzbsHistory.apiGetPurchase(this.listConfig, this.filterConfig).subscribe((purchases) => {
                    Util.log('history list', purchases);

                    this.listConfig.increstSkip();
                    //check is there are more campaign.
                    if (purchases && purchases.length < this.listConfig.defaultTopAmount) {
                        this.listConfig.setSeeMoreEnable(false);
                    }
                    //reinitialize list if no skip.
                    if (this.listConfig.intSkip == this.listConfig.defaultTopAmount) {
                        this.purchases = [];
                    }

                    for (let purchase of purchases) {
                        //TODO: Add GA Tracking.
                        this.purchases.push(purchase);
                    }

                    this.isLoading = false;
                    this.isLoaded = true;
                    this.isHaveItem = this.purchases.length > 0 ? true : false;
                    resolve();
                }, (err) => {
                    resolve();
                    this.isLoading = false;
                    this.isLoaded = true;
                    this.isHaveItem = false;
                    this.errorApi(err);
                });
            });
        },

        loadMore: function() {
            if (!this.listConfig.isSeeMoreEnable) {
                return;
            }

            if (this.isLoading) {
                return;
            }
            this.getList();
        },
        //#endregion history list

        //#region action history
        clickPurchase: function (purchase) {
            //check internet stuff.
            if (this.isSerialLoading) {
                return;
            }

            
            if (purchase.type === CampaignType.Interface) {
                this.openInterfaceHistory(purchase);
                return;
            }

            this.isSerialLoading = true;
            BzbsHistory.apiRedeemDetail(purchase.redeemKey).subscribe({
                next: (result) => {
                    this.isSerialLoading = false;
                    purchase.updateAfterRedeem(result);

                    if (this.isShowSerialModal(purchase)) {
                        this.openSerial(purchase);
                    }
                    // TODO ถ้ามีไรแปลกๆ ก็เปิด comment นี้ได้ (Chat)
                    // else {
                    //     this.refreshList();
                    // }
                },
                error: (err) => {
                    this.isSerialLoading = false;
                    console.log(err);
                },
            });
        },

        openSerial: function(purchase) {
            let serialModel = new SerialModel();
            serialModel.setModelFromDataModel(purchase);

            console.log('open serial');
            this.modal.serialModal
                    .clearModal()
                    .setSerial(serialModel)
                    .show();
            this.modal.serialModal.onSerialExpire(() => {
                purchase.setPurchaseExpired();
                this.refreshList();
            });
        },

        openInterfaceHistory: function(purchase) {
            let sToken = Account.getTokenShuffle();
            let locale = Locale.getLocaleCode();
            let header = 'false';
            let theme = ConfigManager.getAppName();
            let returnUrl = encodeURIComponent(window.location.href);

            // new generation landing interface
            if (purchase.privilegeMessageFormat == 'link') {
                let url = purchase.privilegeMessage;

                url = url.replace('<campaign_id>', purchase.id);
                url = url.replace('<token>', sToken);
                url = url.replace('<serial>', purchase.serial);
                url = url.replace('<locale>', Locale.getLocaleCode());

                url += '&return_url=' + returnUrl;

                window.location.replace(url);
                return;
            }

            let interfaceController = new WebInterfaceController(purchase);
            let historyCount = interfaceController.getHistoryCount();
            // console.log(returnUrl.indexOf('?'))
            returnUrl = window.location.href;
            if (returnUrl.indexOf('?') == -1) {
                returnUrl = returnUrl + '?back=' + historyCount;
            } else {
                returnUrl = returnUrl + '&back=' + historyCount;
            }
            returnUrl = encodeURIComponent(returnUrl);

            // old default landing interface
            if (purchase.website && purchase.website.indexOf('starbucks') > 0) {
                let url = purchase.website +
                        '&token=' + sToken +
                        '&locale=' + locale +
                        '&RedeemKey=' + purchase.redeemKey +
                        '&header=' + header +
                        '&theme=' + theme +
                    '&return_url=' + returnUrl; // ReturnUrl;
                window.location = url;
            } else if (purchase.website && purchase.website.indexOf('linesticker') > 0) {
                let url = purchase.website
                        + "&info2=" + purchase.info2
                        + "&info3=" + purchase.info3
                        + "&locale=" + locale
                        + "&return_url=" + returnUrl
                        + "&token=" + sToken
                        + "&is_history=true";
                window.location = url;
            }
        },

        isShowSerialModal: function (purchase) {
            if (purchase.serial === 'XXXXXXX') {
                return false;
            }
            if (purchase.expireIn && purchase.expireIn <= 0) {
                return false;
            }

            if (purchase.type === CampaignType.Interface) {
                if (purchase.pointType === "get")
                    return false;

                return true;
            }

            if (purchase.type === CampaignType.Free ||
                purchase.type === CampaignType.Deal ||
                purchase.type === CampaignType.Buy) {
                if (purchase.delivered) {
                    return false;
                }
            }

            if (purchase.type === CampaignType.Draw) {
                return false;
            }

            return true;
        },

        refreshList: function () {
            let tmp = this.purchases;
            this.purchases = [];

            this.$nextTick().then( () => {
                this.purchases = tmp;
            });
        },
        //#endregion action history

        callPhone: function() {
            window.open("tel:026451203");
        }
    },
}
</script>
<style lang="scss" scoped>
    .history-list {
        max-width: 500px;
    }
</style>
